import React from 'react'

const CommaFormater = ({ number }) => {
    return Intl.NumberFormat("en-IN", {
        maximumFractionDigits: 2,
    }).format(number)
}

export default CommaFormater